/** Platform-wide no-card trial length (days). Single source of truth for billing gates and marketing copy. */
export const PLATFORM_TRIAL_DAYS = 7;
